export default {
  getDefaultState: () => {
    return {
      customer: {},
      customers: [],
      filters: {},
      currentPage: 1,
      lastPage: 1,
      totalItems: 0,
      isCallingCustomers: false,
      errors: []
    }
  }
}
